<div class="theme-pwa" [formGroup]="pwa()">
    <h4 class="section-title">Manifest Branding</h4>
    <p class="section-subtitle">
        Installable app settings for privileged routes like producer, admin, and
        broadcast views.
    </p>

    <div class="grid">
        <!-- Names (left) + description (right). -->
        <div class="card branding">
            <div class="col">
                <tools-input-outline
                    label="App Name (Full)"
                    placeholder="e.g., MayorDrop"
                    formControlName="pwaName"
                ></tools-input-outline>
                <p class="hint">
                    Full name on the home screen. Falls back to show name if not
                    set.
                </p>

                <tools-input-outline
                    label="App Name (Short)"
                    placeholder="e.g., MayorDrop"
                    formControlName="pwaNameShort"
                ></tools-input-outline>
                <p class="hint">
                    Short name when space is limited. Falls back to the full
                    name.
                </p>
            </div>

            <div class="col">
                <h5 class="card-title">App Description</h5>
                <p class="card-subtitle">
                    Brief description shown in app stores and system dialogs.
                </p>
                <tools-textarea
                    placeholder="e.g., Send a note to Life With John Mayer"
                    formControlName="pwaDescription"
                ></tools-textarea>
            </div>
        </div>

        <!-- Colors card (left) + app icons card (right). -->
        <div class="pair">
            <div class="card colors">
                <div class="field">
                    <h5 class="card-title">Theme Color</h5>
                    <div class="color-row">
                        <!--
                            Native swatch: previews the hex and opens the OS color picker. It only
                            accepts #RRGGBB, so it mirrors the hex control (fallback white) rather
                            than binding to it — the hex text field is the source of truth.
                        -->
                        <div class="swatch-frame">
                            <input
                                type="color"
                                class="swatch"
                                aria-label="Theme color picker"
                                [value]="
                                    swatchColor(
                                        pwa().controls.pwaThemeColor.value
                                    )
                                "
                                (input)="
                                    onColorPicked(
                                        pwa().controls.pwaThemeColor,
                                        $event
                                    )
                                "
                            />
                        </div>
                        <tools-input-outline
                            class="hex"
                            label="Hex Code"
                            placeholder="#FFFFFF"
                            formControlName="pwaThemeColor"
                        ></tools-input-outline>
                    </div>
                    <p class="hint">
                        Browser UI chrome color on supported platforms.
                    </p>
                </div>

                <div class="field">
                    <h5 class="card-title">Background Color</h5>
                    <div class="color-row">
                        <div class="swatch-frame">
                            <input
                                type="color"
                                class="swatch"
                                aria-label="Background color picker"
                                [value]="
                                    swatchColor(
                                        pwa().controls.pwaBackgroundColor.value
                                    )
                                "
                                (input)="
                                    onColorPicked(
                                        pwa().controls.pwaBackgroundColor,
                                        $event
                                    )
                                "
                            />
                        </div>
                        <tools-input-outline
                            class="hex"
                            label="Hex Code"
                            placeholder="#FFFFFF"
                            formControlName="pwaBackgroundColor"
                        ></tools-input-outline>
                    </div>
                    <p class="hint">Color shown while the app is loading.</p>
                </div>
            </div>

            <div class="card icons">
                <div class="field">
                    <h5 class="card-title">App Icon (192x192px)</h5>
                    <p class="card-subtitle">
                        Home screen icon. Square PNG recommended.
                    </p>
                    <app-image-upload
                        class="app-icon"
                        label="192 pixel app icon"
                        promptText="Upload Image"
                        [initialUrl]="
                            pwa().controls.pwaAppIcon192Url.value || null
                        "
                        (uploaded)="onIcon192Uploaded($event)"
                    ></app-image-upload>
                    <p class="hint">JPEG, PNG, GIF, WebP, SVG.</p>
                </div>

                <div class="field">
                    <h5 class="card-title">App Icon (512x512px)</h5>
                    <p class="card-subtitle">
                        High-resolution icon for install prompts and larger
                        displays.
                    </p>
                    <app-image-upload
                        class="app-icon"
                        label="512 pixel app icon"
                        promptText="Upload Image"
                        [initialUrl]="
                            pwa().controls.pwaAppIcon512Url.value || null
                        "
                        (uploaded)="onIcon512Uploaded($event)"
                    ></app-image-upload>
                    <p class="hint">JPEG, PNG, GIF, WebP, SVG.</p>
                </div>
            </div>
        </div>
    </div>
</div>
